import { Card } from './card';
import { Player } from './player';
import { Game } from './game';

let game = new Game();

// console.log(game);

export { game }